import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { createElement } from "commonAssets/lib/createElement";
import { appPayMethod, i18n } from "commonAssets/js/constants";
import { modal } from "commonAssets/js/helpers";
import { ErrorHandler } from "commonAssets/js/classes";

export class customSubmitClaim extends SubmitClaim {
    claim_form(params) {
        const form = createElement(
            "form",
            {
                class: "needs-validation",
                id: "form",
                method: "post",
            },
            [
                this.claim_instructions(params),
                this.claim_contact_information(params),
                // Include claim_fields to render In-Game Cash fields (hidden)
                this.claim_fields(params),
                this.claim_transactions(params),
                params.claim_upload &&
                params.claim_upload.documentation &&
                params.claim_upload.documentation.required
                    ? this.claim_documentation(params)
                    : ``,
                appPayMethod ? this.claim_payment_method(params) : ``,
                this.claim_certification(params),

                // Hidden payment fields required by Digital Disbursements
                createElement("input", {
                    type: "hidden",
                    id: "payment_method",
                    name: "payment_method",
                    value: "",
                    "data-label": "Payment Method",
                }),
                createElement("input", {
                    type: "hidden",
                    id: "payment_token",
                    name: "payment_token",
                    value: "",
                    "data-label": "Payment Token",
                }),
                createElement("input", {
                    type: "hidden",
                    id: "payment_email",
                    name: "payment_email",
                    value: "",
                    "data-label": "Payment Email",
                }),
                createElement("input", {
                    type: "hidden",
                    id: "payment_phone",
                    name: "payment_phone",
                    value: "",
                    "data-label": "Payment Phone",
                }),

                // Hidden field to capture payment option selection for form system
                createElement("input", {
                    type: "hidden",
                    id: "payment_option",
                    name: "payment_option",
                    value: "",
                    "data-label": "Payment Option",
                }),
            ]
        );
        return form;
    }

    claim_payment_method(params) {
        const fieldset = createElement(
            "fieldset",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "payment-widget",
            },
            [
                createElement(
                    "legend",
                    { class: "mb-3", id: "paymentWidgetLegend" },
                    [],
                    params.form_options.claim_form.payment_widget.title
                ),
                createElement(
                    "p",
                    { class: "mb-3", id: "paymentWidgetMessage" },
                    [],
                    params.form_options.claim_form.payment_widget.body
                ),
                createElement(
                    "p",
                    {
                        class: "d-none",
                        id: "update_payment_message",
                    },
                    [],
                    `You have successfully requested a <span id="previous_payment_method"></span> payment. <span id="update_payment_toggle">Click here if you would like to choose a different payment method.</span>`
                ),

                // Payment selection with In-Game Cash option
                this.createPaymentSelection(),

                createElement(
                    "script",
                    {
                        type: "text/javascript",
                    },
                    [],
                    `
              dstPaymentForm(document.getElementById('dst-payment'),
                {
                  verify: false,
                  onSubmitted: function (info) { 
                    document.getElementById('payment_method').value = info.method; 
                    document.getElementById('payment_token').value = info.token; 
                    if (info.paymentEmail) {
                        document.getElementById('payment_email').value = info.paymentEmail; 
                    }
                    if (info.paymentPhone) {
                        document.getElementById('payment_phone').value = info.paymentPhone; 
                    }
                  }
                }
              )
            `
                ),
            ]
        );

        return fieldset;
    }

    createPaymentSelection() {
        console.log("Creating payment selection options");

        // Set up event handlers after the DOM is created
        setTimeout(() => {
            this.setupPaymentHandlers();
        }, 100);

        return createElement(
            "div",
            {
                class: "mb-4",
                id: "payment-selection",
            },
            [
                // Digital Payment Option
                createElement("div", { class: "form-check mb-3" }, [
                    createElement("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "payment_option",
                        id: "digital-payment",
                        value: "digital",
                        required: true,
                    }),
                    createElement(
                        "label",
                        { class: "form-check-label", for: "digital-payment" },
                        [],
                        "Digital Payment (PayPal, Venmo, Zelle, Virtual Prepaid Card)"
                    ),
                ]),

                // Digital Disbursements widget (hidden until Digital Payment is selected)
                createElement(
                    "div",
                    {
                        id: "dst-payment-container",
                        class: "ms-4 mb-4 d-none",
                    },
                    [
                        createElement("div", {
                            id: "dst-payment",
                            key: appPayMethod,
                        }),
                    ]
                ),

                // In-Game Cash distribution option
                createElement("div", { class: "form-check mb-3" }, [
                    createElement("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "payment_option",
                        id: "in-game-cash",
                        value: "ingame",
                        required: true,
                    }),
                    createElement(
                        "label",
                        { class: "form-check-label", for: "in-game-cash" },
                        [],
                        "In-Game Cash distribution"
                    ),
                ]),

                // In-Game Cash details container (initially hidden, will be populated from form fields)
                createElement("div", {
                    class: "ms-4 d-none",
                    id: "in-game-details",
                }),
            ]
        );
    }

    populate_claim_form(form, container, claim, claim_deadline) {
        const isClaimant = claim.claim_id != null;
        const isClaimEditable = isClaimant ? claim.class_member?.is_claim_editable : claim.is_claim_editable;
        const isClaimDeficient = isClaimant ? claim.class_member?.is_claim_deficient : claim.is_claim_deficient;
        const deficiencyReasons = isClaimant ? claim.class_member?.deficiency_reasons : claim.deficiency_reasons;
        const doesClaimHaveTransactions = isClaimant && claim.claim_transactions.length > 0;
        const doesClaimHaveFiles = isClaimant && claim.claim_files.length > 0;

        if (isClaimEditable !== 1) {
            this.errorHandler.display({
                status: 403,
                error: 'This claim is no longer editable. Please contact the settlement administrator for assistance.'
            });
            return;
        }

        this.claim.is_deficient = isClaimDeficient === 1;
        this.claim.deficiency_reasons = deficiencyReasons?.split(',') ?? [];
        this.claim.has_transactions = doesClaimHaveTransactions;
        this.claim.has_files = doesClaimHaveFiles;

        super.populate_claim_form(form, container, claim, claim_deadline);

        // Set up payment handlers after form is populated
        setTimeout(() => {
            this.setupPaymentHandlers();
        }, 100);
    }

    init_claim_inputs() {
        super.init_claim_inputs();

        const papayaFields = document.querySelectorAll(
            '#payment-widget input[name^="papaya_phone"], #payment-widget input[name="papaya_game"]'
        );
        const paymentOptionField = document.getElementById("payment_option");

        if (!this.claim?.inputs?.fields) {
            this.claim.inputs.fields = [];
        }

        papayaFields.forEach((field) => {
            if (field && !this.claim.inputs.fields.includes(field)) {
                this.claim.inputs.fields.push(field);
            }
        });

        if (
            paymentOptionField &&
            !this.claim.inputs.fields.includes(paymentOptionField)
        ) {
            this.claim.inputs.fields.push(paymentOptionField);
        }
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    setupPaymentHandlers() {
        const digitalRadio = document.getElementById("digital-payment");
        const inGameRadio = document.getElementById("in-game-cash");
        const inGameDetails = document.getElementById("in-game-details");
        const dstPaymentContainer = document.getElementById(
            "dst-payment-container"
        );

        // Find the form fields in the claim fields section
        // Form builder appends numeric suffixes to text input names, so use a prefix selector
        const papayaPhoneField = document.querySelector(
            'input[name^="papaya_phone"]'
        );
        const papayaGameInput = document.querySelector(
            'input[name="papaya_game"]'
        );
        const papayaGameFieldset = papayaGameInput?.closest(
            "fieldset, .form-group, .mb-3"
        );
        const papayaGameLabel = papayaGameInput?.getAttribute("data-label");

        // Find the hidden payment_option form field (created manually)
        const paymentOptionField = document.getElementById("payment_option");

        const validatePapayaPhoneInput = (showFeedback = false) => {
            if (!papayaPhoneField) return true;
            const digitsOnly = papayaPhoneField.value.replace(/\D/g, "");
            const isValid = digitsOnly.length >= 10;
            if (isValid) {
                papayaPhoneField.setCustomValidity("");
                papayaPhoneField.classList.remove("is-invalid");
            } else {
                papayaPhoneField.setCustomValidity(
                    "Please enter at least 10 digits."
                );
                if (showFeedback) {
                    papayaPhoneField.reportValidity();
                }
                if (inGameRadio?.checked) {
                    papayaPhoneField.classList.add("is-invalid");
                }
            }
            return isValid;
        };

        if (papayaPhoneField) {
            papayaPhoneField.addEventListener("input", () => {
                if (inGameRadio?.checked) {
                    validatePapayaPhoneInput();
                } else {
                    papayaPhoneField.setCustomValidity("");
                    papayaPhoneField.classList.remove("is-invalid");
                }
            });
        }

        if (
            digitalRadio &&
            inGameRadio &&
            inGameDetails &&
            dstPaymentContainer
        ) {
            console.log("Setting up payment type handlers");

            // Simply move the original fields from claim_fields to the payment widget
            if (inGameDetails) {
                const phoneContainer =
                    papayaPhoneField?.closest(".form-group, .mb-3, .row") ||
                    papayaPhoneField?.parentElement;
                const gameContainer =
                    papayaGameFieldset?.closest(
                        ".form-group, .mb-3, .row, fieldset"
                    ) || papayaGameFieldset;

                if (phoneContainer) {
                    inGameDetails.appendChild(phoneContainer);
                    papayaPhoneField.classList.remove("d-none");
                    phoneContainer.classList.remove("d-none");
                    phoneContainer
                        .querySelectorAll(".d-none")
                        .forEach((el) => el.classList.remove("d-none"));
                    phoneContainer.classList.add("papaya-phone-wrapper");
                }

                if (gameContainer) {
                    inGameDetails.appendChild(gameContainer);

                    // Inject missing field label above the radio options for clarity
                    if (
                        papayaGameLabel &&
                        !gameContainer.querySelector(".papaya-game-label")
                    ) {
                        const groupLabel = document.createElement("label");
                        groupLabel.className =
                            "form-label fw-semibold papaya-game-label";
                        groupLabel.textContent = papayaGameLabel;
                        gameContainer.prepend(groupLabel);
                    }

                    const gameRadios = gameContainer.querySelectorAll(
                        'input[name="papaya_game"]'
                    );
                    gameRadios.forEach((radio) =>
                        radio.classList.remove("d-none")
                    );
                    gameContainer.classList.remove("d-none");
                    gameContainer
                        .querySelectorAll(".d-none")
                        .forEach((el) => el.classList.remove("d-none"));
                }
            }

            digitalRadio.addEventListener("change", function () {
                if (this.checked) {
                    console.log("Digital Payment selected");
                    dstPaymentContainer.classList.remove("d-none");
                    inGameDetails.classList.add("d-none");

                    // Set the hidden form field for automatic form capture
                    if (paymentOptionField)
                        paymentOptionField.value = "digital";

                    // Hide In-Game Cash fields in the payment widget
                    inGameDetails.classList.add("d-none");

                    // Disable validation for the moved fields
                    const movedPhone = inGameDetails.querySelector(
                        'input[name^="papaya_phone"]'
                    );
                    const movedGameRadios = inGameDetails.querySelectorAll(
                        'input[name="papaya_game"]'
                    );

                    if (movedPhone) movedPhone.required = false;
                    if (movedPhone) {
                        movedPhone.setCustomValidity("");
                        movedPhone.classList.remove("is-invalid");
                    }
                    movedGameRadios.forEach(
                        (radio) => (radio.required = false)
                    );

                    // Clear payment method values for DST to handle
                    const paymentMethod =
                        document.getElementById("payment_method");
                    const paymentToken =
                        document.getElementById("payment_token");
                    if (paymentMethod) paymentMethod.value = "";
                    if (paymentToken) paymentToken.value = "";
                }
            });

            inGameRadio.addEventListener("change", function () {
                if (this.checked) {
                    console.log("In-Game Cash selected");
                    dstPaymentContainer.classList.add("d-none");
                    inGameDetails.classList.remove("d-none");

                    // Set the hidden form field for automatic form capture
                    if (paymentOptionField) paymentOptionField.value = "ingame";

                    // Show In-Game Cash fields in the payment widget
                    inGameDetails.classList.remove("d-none");

                    // Enable validation for the moved fields (no syncing needed since they're the originals)
                    const movedPhone = inGameDetails.querySelector(
                        'input[name^="papaya_phone"]'
                    );
                    const movedGameRadios = inGameDetails.querySelectorAll(
                        'input[name="papaya_game"]'
                    );

                    if (movedPhone) movedPhone.required = true;
                    if (movedPhone) validatePapayaPhoneInput();
                    movedGameRadios.forEach((radio) => {
                        radio.required = true;
                    });

                    // Clear DST-specific hidden values since they're not used for in-game payouts
                    const paymentMethodField =
                        document.getElementById("payment_method");
                    const paymentTokenField =
                        document.getElementById("payment_token");
                    const paymentEmailField =
                        document.getElementById("payment_email");
                    const paymentPhoneField =
                        document.getElementById("payment_phone");
                    if (paymentMethodField) paymentMethodField.value = "";
                    if (paymentTokenField) paymentTokenField.value = "";
                    if (paymentEmailField) paymentEmailField.value = "";
                    if (paymentPhoneField) paymentPhoneField.value = "";

                    // For In-Game Cash, we don't use payment_method/payment_token (those are for DST)
                    // Instead, we rely on custom claim fields: payment_option, papaya_phone, papaya_game
                    // These are automatically captured by the form system
                }
            });
        } else {
            console.log("Payment type elements not found for event setup");
        }
    }
}

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");

    // Initialize payment fields with default values to prevent modal
    setTimeout(() => {
        const paymentMethod = document.getElementById("payment_method");
        const paymentToken = document.getElementById("payment_token");

        if (paymentMethod && !paymentMethod.value) {
            paymentMethod.value = "not_selected";
        }
        if (paymentToken && !paymentToken.value) {
            paymentToken.value = "not_selected";
        }
    }, 50);

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    const normalizePaymentLabel = (value = "") => value.trim();
    const isValidPaymentLabel = (value = "") => {
        const normalized = normalizePaymentLabel(value);
        return (
            !!normalized && normalized.toLowerCase() !== "not_selected"
        );
    };

    const showSavedSelection = (label) => {
        if (!isValidPaymentLabel(label)) return;

        const updateMessage = document.getElementById("update_payment_message");
        const paymentSelection = document.getElementById("payment-selection");
        const previousMethod = document.getElementById(
            "previous_payment_method"
        );
        const updateToggle = document.getElementById("update_payment_toggle");
        const paymentWidgetBody = document.getElementById(
            "paymentWidgetMessage"
        );

        if (!updateMessage || !paymentSelection || !previousMethod) return;

        previousMethod.innerText = normalizePaymentLabel(label);
        updateMessage.classList.remove("d-none");
        if (paymentWidgetBody) paymentWidgetBody.classList.add("d-none");
        paymentSelection.classList.add("d-none");
        paymentSelection.style.display = "none";
        paymentSelection.hidden = true;

        if (updateToggle && !updateToggle.dataset.bound) {
            updateToggle.dataset.bound = "true";
            updateToggle.addEventListener("click", () => {
                updateMessage.classList.add("d-none");
                if (paymentWidgetBody)
                    paymentWidgetBody.classList.remove("d-none");
                paymentSelection.classList.remove("d-none");
                paymentSelection.style.display = "";
                paymentSelection.hidden = false;
            });
        }
    };

    const claimFields = claim?.class_member?.claim_fields || [];
    const getFieldValue = (label) =>
        claimFields.find((field) => field.name === label)?.value || "";

    const savedPaymentOption = getFieldValue("Payment Option").toLowerCase();
    const savedPapayaPhone = getFieldValue(
        "Phone number associated with your Papaya account:"
    );
    const savedPapayaGame = getFieldValue(
        "Select which Papaya game to receive your payment (select one):"
    );

    setTimeout(() => {
        const digitalRadio = document.getElementById("digital-payment");
        const inGameRadio = document.getElementById("in-game-cash");
        const hiddenPaymentOption = document.getElementById("payment_option");
        const papayaPhoneInput = document.querySelector(
            'input[name^="papaya_phone"]'
        );
        const papayaGameRadios = document.querySelectorAll(
            'input[name="papaya_game"]'
        );
        const rawExistingPaymentMethod =
            document.getElementById("payment_method")?.value || "";
        const normalizedExistingPaymentMethod = normalizePaymentLabel(
            rawExistingPaymentMethod
        );
        const hasExistingPaymentSelection = isValidPaymentLabel(
            rawExistingPaymentMethod
        );

        if (savedPaymentOption === "ingame") {
            if (hiddenPaymentOption) hiddenPaymentOption.value = "ingame";
            if (inGameRadio) inGameRadio.checked = true;
            if (papayaPhoneInput && savedPapayaPhone) {
                papayaPhoneInput.value = savedPapayaPhone;
            }
            if (savedPapayaGame) {
                papayaGameRadios.forEach((radio) => {
                    radio.checked = radio.value === savedPapayaGame;
                });
            }
            showSavedSelection("In-Game Cash distribution");
        } else if (savedPaymentOption === "digital") {
            if (hiddenPaymentOption) hiddenPaymentOption.value = "digital";
            if (digitalRadio) digitalRadio.checked = true;
            const label = hasExistingPaymentSelection
                ? normalizedExistingPaymentMethod
                : "Digital Payment";
            showSavedSelection(label);
        } else if (hasExistingPaymentSelection) {
            if (hiddenPaymentOption) hiddenPaymentOption.value = "digital";
            if (digitalRadio) digitalRadio.checked = true;
            showSavedSelection(normalizedExistingPaymentMethod);
        }
    }, 150);

    return claim;
}

// This function is no longer needed - functionality moved to class setupPaymentHandlers method

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");

    // All form field values (payment_option, papaya_phone, papaya_game) are automatically
    // captured in claim.data by the form system from the claim_fields definitions

    // For Digital Payment, the DST widget handles setting payment_method and payment_token
    // For In-Game Cash, we rely on the custom claim fields:
    // - claim.data.payment_option = 'ingame'
    // - claim.data.papaya_phone = user's phone number
    // - claim.data.papaya_game = selected game (e.g., 'Solitaire Cash')

    // The backend API will use these custom fields to process In-Game Cash distributions
    // No need to set payment_method/payment_token for custom payment options

    const paymentOption =
        claim.data.payment_option || claim.data.fields?.["Payment Option"];
    const papayaPhone =
        claim.data.papaya_phone ||
        claim.data.fields?.[
            "Phone number associated with your Papaya account:"
        ];
    const papayaGame =
        claim.data.papaya_game ||
        claim.data.fields?.[
            "Select which Papaya game to receive your payment (select one):"
        ];

    // Persist normalized values for downstream processing
    if (paymentOption && !claim.data.payment_option) {
        claim.data.payment_option = paymentOption;
    }
    if (papayaPhone && !claim.data.papaya_phone) {
        claim.data.papaya_phone = papayaPhone;
    }
    if (papayaGame && !claim.data.papaya_game) {
        claim.data.papaya_game = papayaGame;
    }

    if (paymentOption === "ingame") {
        const phoneInput = document.querySelector(
            'input[name^="papaya_phone"]'
        );
        if (phoneInput) {
            phoneInput.classList.remove("is-invalid");
            phoneInput.setCustomValidity("");
        }

        const digitsOnly = (papayaPhone || "").replace(/\D/g, "");
        if (!digitsOnly || digitsOnly.length < 10) {
            claim.flags.valid = false;
            if (phoneInput) {
                phoneInput.classList.add("is-invalid");
                phoneInput.setCustomValidity(
                    "Please enter at least 10 digits."
                );
                phoneInput.reportValidity();
                phoneInput.focus();
            }
            modal(
                i18n.getTranslation("error"),
                "Please enter a valid phone number associated with your Papaya account."
            );
            return claim;
        }
    } else if (paymentOption === "digital") {
        if (claim.data.fields) {
            delete claim.data.fields[
                "Phone number associated with your Papaya account:"
            ];
            delete claim.data.fields[
                "Select which Papaya game to receive your payment (select one):"
            ];
            if (claim.data.fields["Payment Token"]) {
                claim.data.fields["Digital Payment Token"] =
                    claim.data.fields["Payment Token"];
            }
        }
        claim.data.papaya_phone = "";
        claim.data.papaya_game = "";
    } else {
        if (claim.data.fields) {
            delete claim.data.fields["Digital Payment Token"];
        }
    }

    console.log("Final claim data being sent to API:", claim.data);
    console.log("Payment option:", paymentOption);
    if (paymentOption === "ingame") {
        console.log(
            "In-Game Cash details - Phone:",
            papayaPhone,
            "Game:",
            papayaGame
        );
    }

    return claim;
}

/**
 * Custom DST Process function to handle our hybrid payment system
 * This overrides the base class DST validation to handle both digital and in-game payments
 */
export function customDstProcess(claim) {
    console.log("[Custom DST Process]...");

    const formPaymentOption =
        claim.data?.payment_option ||
        claim.data?.fields?.["Payment Option"] ||
        document.getElementById("payment_option")?.value;
    const selectedPaymentOption = document.querySelector(
        'input[name="payment_option"]:checked'
    );
    const paymentChoice =
        formPaymentOption || selectedPaymentOption?.value || "";

    // Block submission if no payment option was selected
    if (!paymentChoice) {
        claim.flags.valid = false;
        modal(
            i18n.getTranslation("error"),
            "Please select a payment method before submitting your claim."
        );
        return claim;
    }

    if (paymentChoice === "digital") {
        // Only validate DST fields for digital payments
        if (
            !document.getElementById("payment_method") ||
            !document.getElementById("payment_token") ||
            !document.getElementById("payment_method").value ||
            !document.getElementById("payment_token").value
        ) {
            claim.flags.valid = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("payment_select_error")
            );
            return claim;
        }

        // Additional DST validation for email matching (if both fields exist)
        if (
            document.getElementById("email_address") &&
            document.getElementById("payment_email") &&
            document.getElementById("email_address").value &&
            document.getElementById("payment_email").value &&
            document.getElementById("email_address").value.toLowerCase() !==
                document.getElementById("payment_email").value.toLowerCase()
        ) {
            claim.flags.valid = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_processing_email_error")
            );
            return claim;
        }

        // Additional DST validation for phone matching (if both fields exist)
        if (
            document.getElementById("phone_number_1") &&
            document.getElementById("payment_phone") &&
            document.getElementById("phone_number_1").value &&
            document.getElementById("payment_phone").value &&
            document
                .getElementById("phone_number_1")
                .value.replace(/\D/g, "") !==
                document
                    .getElementById("payment_phone")
                    .value.replace(/\D/g, "")
        ) {
            claim.flags.valid = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_processing_phone_error")
            );
            return claim;
        }
    }
    return claim;
}
